<template>
    <div class="certificate">
        <div class="list">
            <div class="list-item " v-for="(item,index) in list" :key="index">
                <div class="tt">{{item.name}}</div>
                <div class="it-list" >
                    <div class="item" v-for="(itemo,indexo) in item.list" :key="indexo" >
                        <div v-if="itemo.my" class="it-item" @click="view(indexo)">
                            <img class="img" v-lazy="itemo.my" />
                            <div class="nn">{{itemo.name}}</div>
                        </div>
                        <div class="it-item item-no" v-else>
                            <img class="img"  v-lazy="itemo.imgurl" />
                            <div class="nn">{{itemo.name}}</div>
                            <!--                        <div class="icon"><img class="icon" :src="itemo.icon" mode="scaleToFill"></img></div>-->
                        </div>
                        <div class="item-name">{{itemo.name}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer btn-list">
            <van-button class="mvbutton" type="primary" size="large" color="#5D97FF" @click="jumpUrl('/my/uploadcert')">上传证件</van-button>
        </div>
    </div>
</template>
<script>
    import './index.less'
    import {Cell, CellGroup, Area, Popup,Field,Tag,Button,ImagePreview,Lazyload} from 'vant'
    export default {
        data() {
            return {
                list:[],
                mylist:[]
            }
        },
        components: {
            Cell,
            CellGroup,
            Area,
            Field,
            Popup,
            Tag,
            vanButton:Button,
            ImagePreview,
            Lazyload
        },
        methods: {
            getCert(){
                this.$api.user.getcert().then((res)=>{
                    this.list = res.data.list
                    this.mylist = res.data.mylist
                })
            },
            jumpUrl(url)
            {
                this.$router.push(url)
            },
            view(index)
            {
                ImagePreview({
                    images: this.mylist,
                    startPosition: index,
                });
            }
        },
        mounted() {
            this.getCert()
        }
    }
</script>
<style lang="less" src="./index.less" scoped></style>
